import angular from 'angular';

class ConfirmPdpConflictCtrl {
    /* @ngInject */
    constructor() {}

    $onInit() {
        this.conflictData = this.resolve.conflictData;
        this.conflictData.startDateExisted = this.formatDate(this.conflictData.startDateExisted);
        this.conflictData.endDateExisted = this.conflictData.endDateExisted ? this.formatDate(this.conflictData.endDateExisted) : null;
    }

    formatDate(dateString) {
        if (!dateString) return null;
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    }

    close() {
        this.modalInstance.dismiss('cancel');
    }

    confirm() {
        this.modalInstance.close('confirmed');
    }
}

angular.module('app.principal').component('confirmPdpConflict', {
    templateUrl: require('./modal-confirm-pdp-conflict.html'),
    controller: ConfirmPdpConflictCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
